<ng-container *ngIf="view === 'full' else ticketView">
  
  <div class="filterRow" *ngIf="!isMobile || (isMobile && mobileStage === 'list')">
    <boardFilter [type]="'messages'" (emitFillters)="initRestOfFilters($event)"></boardFilter>
  </div>
  <ng-container *ngIf="!isMobile else mobileView">
    <div class="body" *ngIf="ticketsList$ | async as tickets">
      <ng-container *ngIf="tickets.length != 0 else noMessages">
        <ng-container id="chatTicketsList"  [ngTemplateOutlet]="ticketList" [ngTemplateOutletContext]="{ticketsList: tickets}" ></ng-container>
        <ng-container id="chatMessagesList"  *ngTemplateOutlet="ticketView" ></ng-container>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #noMessages>
  <div class="noMessagesContainer ">
    <img class="noMessagesImg" [src]="'./assets/img/noMessages.svg'" alt="">
    <div class="noMessagesText" [ngClass]="{'noMessagesText_mobile': isMobile}">
      {{'SERVICE.NO_MESSAGES_TEXT' | translate}}
    </div>
  </div>
</ng-template>

<ng-template #mobileView>
  <div class="body mobileBody" *ngIf="ticketsList$ | async as tickets">
    <ng-container *ngIf="tickets.length != 0 else noMessages">
      <ng-container id="chatMessagesList" [ngTemplateOutlet]="ticketList" [ngTemplateOutletContext]="{ticketsList: tickets}"  ></ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #ticketList let-data = ticketsList>
    <div class="listContainer" [style.height]="getMatDesiredHeight('container')" [ngClass]="{'listContainer_mobile': isMobile}" *ngIf="isMobile && mobileStage === 'list' || !isMobile">
      <lib-chat-ticket-list  
        #ticektsList
        id="chatTicketList" 
        [ticketsList]="data" 
        (onSelectTicket)="onSelectTicket($event)"
        [selected]="defultSelected"
      ></lib-chat-ticket-list>
    </div>
    <div class="chatBox_mobile_container" *ngIf="isMobile && mobileStage === 'chat'">
      <img src="./assets/img/Back.svg" alt="" class="backArrowImage" (click)="updateStage('list')" *ngIf="isMobile">
      <ng-container *ngTemplateOutlet="ticketData"></ng-container>
      <ng-container id="chatMessagesList"  *ngTemplateOutlet="ticketView" ></ng-container>
    </div>
  
</ng-template>

<ng-template #ticketView>
  <div class="chatBox" *ngIf="selectedTicket " [ngClass]="{'chatBox_mobile': isMobile}" [style.height]="getMatDesiredHeight('container')" >
    <div *ngIf="!isMobile">
      <ng-container *ngTemplateOutlet="ticketData"></ng-container>
    </div>
   
    <div class="chatMessages" [style.height]="getMatDesiredHeight('chat')"  #chatMessages [ngClass]="{'mobileChatMessages': isMobile}" [style.min-height]="getMatDesiredMinHeight('minChat')">
      <lib-chat-box 
        [view]  = "view"
        [records]="records$ | async" 
        (onOpenImage)="handleCarouselEvents($event)" 
        [chatLoading]="chatLoading"
        [ngClass]="{'chatMessagesWithFilesInInput': filesCount > 0}"
        (onOpenCallTranscript)="onOpenCallTranscript($event)"
      >
        <app-service-review  [selectedTicketData]="selectedTicket"></app-service-review>
      </lib-chat-box>
    </div>
    <div id="chatInputBox" #chatInputBox>
      <chat-input
        *ngIf="!loading"
        class="messageInput" 
        [ngClass]="{'disabled' : selectedTicket?.disabled,'mobileMessageInput': isMobile}"
        [task_ticket_id]="selectedTicket?.id" 
        (noteAdded)="noteAdded($event)" 
        [chatType]="'full'" 
        [userData]="userData"
        [heightCarousel]="50"
        (onFilesUploaded)="filesCount = $event"
        [disabled]="selectedTicket?.disabled"
      ></chat-input>
    </div>
  </div>

</ng-template>

<ng-template #ticketData>
  <div class="ticketData" *ngIf="view === 'full'">
    <div class="top"  [ngClass]="{'top_mobile': isMobile}">
      <div class="category" [ngClass]="{'category_mobile': isMobile}">{{selectedTicket.category.label}}</div>
      <div class="ticketNumber">#{{selectedTicket.ticketNumber}}</div>
      <span class="rounded-and-filled ticket-status {{selectedTicket?.displayStatus?.statusClass}}">{{selectedTicket?.displayStatus?.text}}</span>
    </div>
    <div class="bottom">{{selectedTicket.address}}</div>
  </div>
</ng-template>

<div class="spinnerBox" *ngIf="loading">
  <home365-loader [white]="false" [size]="'xxl'"></home365-loader>
</div>